---
title: "Pakete senden"
slug: sending-a-package
description: "Schritt-für-Schritt-Anleitung zum Scannen und Versenden eines Pakets an einen internen oder externen Standort."
keywords:
  - senden
  - Paket
  - Scan
  - GRAI
  - Standort
  - Empfänger
  - versenden
---

## Voraussetzungen

- Rolle: Scanner, Manager oder Company Admin
- Mindestens ein interner Standort muss Ihrem Konto zugewiesen sein
- Das Paket muss eine gültige GRAI-Kennung tragen

## Schritt für Schritt

1. Navigieren Sie im oberen Menü zu **Senden**.
2. Wählen Sie Ihren aktuellen Standort aus dem Dropdown **Aktueller Standort**.
3. Scannen Sie den QR-Code auf dem Paket mit der Kamera oder geben Sie die GRAI manuell über **Paket-ID eingeben** ein.
4. Wählen Sie den Empfänger:
   - **Nächster interner Standort** — wählen Sie einen Ihrer internen Standorte aus der Dropdown-Liste.
   - **Externes Ziel** — wählen Sie ein bestehendes externes Ziel aus der Liste oder legen Sie ein neues an.
   - **Shopify-Bestellung** — suchen Sie nach einer Bestellung (optional), um die Sendung mit einer Bestellung zu verknüpfen.
5. Füllen Sie bei Bedarf das Feld **Bestell-ID (optional)** mit Ihrer internen Referenz aus.
6. Fügen Sie unter **Beschreibung (optional)** Hinweise zur Sendung hinzu, z. B. Zustand oder Sonderwünsche.
7. Klicken Sie auf **Paket versenden**, um den Versand zu bestätigen.
8. Der Versand erscheint sofort unter **Letzte Aktivität** im Scanner-Bereich.

## Wenn es schiefgeht

- **"Paket nicht gefunden"** — Die GRAI ist möglicherweise noch nicht registriert. Verwenden Sie die Funktion **Als neues Paket registrieren**, um es anzulegen.
- **"Sie sind nicht berechtigt, von diesem Standort zu versenden"** — Ihre zugewiesene Rolle erlaubt keinen Versand von diesem Standort. Wenden Sie sich an Ihren Company Admin.
- **"Box bereits seit ... im Versand"** — Das Paket befindet sich noch im aktiven Versand. Bitten Sie den Empfängerstandort, das Paket zunächst als empfangen zu markieren.
- **Netzwerkfehler beim Versand** — Der Versand wurde nicht gespeichert. Prüfen Sie Ihre Internetverbindung und versuchen Sie es erneut.
- Kontaktieren Sie uns: support@heycircle.com oder nutzen Sie die Feedback-Schaltfläche unten rechts auf dem Bildschirm.

## Verwandte Artikel

- [Pakete empfangen](/app/help?article=scanning-a-package)
- [Defekt melden](/app/help?article=reporting-a-defect)
- [Ersteinrichtung](/app/help?article=initial-setup)
